import HeroIcon from "./HeroIcon";
import TruncateTooltip from "./TruncateTooltip";
import { Workflow } from "./interface";
import { useTranslation } from "react-i18next";

interface Props {
  workflow: Workflow;
  onSelect: (workflow: Workflow) => void;
}

function InstantWorkflowCard(props: Props) {
  const { t } = useTranslation();
  const { workflow } = props;

  return (
    <div
      className="card-hover-ring flex flex-col justify-between gap-3 h-full flex-1 min-w-0 border border-gray-200 bg-white rounded-lg p-6 cursor-pointer"
      onClick={() => props.onSelect(workflow)}
    >
      <div className="flex flex-col gap-3 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <TruncateTooltip label={workflow.name} className="font-bold font-gilroy text-sm text-black" />
          <HeroIcon icon={workflow.icon} className="w-6 h-6 flex-shrink-0 text-gray-600" />
        </div>
        <div className="text-xs text-gray-500 leading-4">
          {workflow.description}
        </div>
      </div>
      <div className="bg-blue-50 text-blue text-xs font-semibold font-gilroy rounded-full px-2 py-0.5 self-start">
        {t("Portant Template")}
      </div>
    </div>
  )
}

export default InstantWorkflowCard;
